import type { TextAreaProps } from '../textInput/TextInput';
import TextInput from '../textInput/TextInput';

export default function TextArea(props: Omit<TextAreaProps, 'multiline'>) {
  return <TextInput {...props} multiline />;
}
